import { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { isIE } from 'react-device-detect'
import { SHOW as ANSWERERRORPAGESHOW } from 'reducer/answerErrorPage'
import { useIntl } from 'react-intl'
import IsTokenContainer from './IsToken'

let timer = null
function Component(props) {

    const dispatch = useDispatch()

    const { formatMessage: f } = useIntl()

    const [ mount, setMount ] = useState(false)

    useEffect(() => {
        if (isIE) {
            dispatch({ type: ANSWERERRORPAGESHOW, buttonHide: true, message: f({id: 'container.Survey.Live.IsIE.message'}) })
        }
    }, [dispatch, f])

    useEffect(() => {
        clearTimeout(timer)
        timer = setTimeout(() => {
            setMount(true)
        }, 1500)

        return () => {
            clearTimeout(timer)
        }
    }, [])

    if (isIE) return null

    if (!mount) return null

    return (
        <IsTokenContainer {...props}/>
    )
}

export default Component